export default "__VITE_ASSET__C3LBE4Z8__"